module.exports = __webpack_public_path__ + "media/images/icons/filled/codepen-square-f6b0e4f74b801258ec70886a6ea1af10.svg";